import React from 'react';
import { connect } from '@cerebral/react';
import { state, signal } from 'cerebral/tags';

import Main from './Main';
import PosterPreview from './PosterPreview';
import PartIntro from './PartIntro';
import PartSection from './PartSection';
import Error from './Error';

const pages = {
    main: Main,
    poster: PosterPreview,
};

const MainPage = ({
    page, parts, section,
}) => {
    // CHECK WITCH PAGE NEED TO BE RENDERED
    let Page = null;
    let currentPart = null;
    let currentSection = null;

    Page = pages[page];
    if (Page) return <Page />;

    currentPart = parts.find(p => p.slug === page);

    if (currentPart && section) {
        currentSection = currentPart.sections.find(s => s.slug === section);
        if (section) {
            return (
                <PartSection
                    part={currentPart}
                    section={currentSection}
                />
            );
        }
    } else if (currentPart) {
        return <PartIntro amount={parts.length} {...currentPart} />;
    }

    return <Error />;
};

const stateSignals = {
    page: state`app.currentPage`,
    section: state`app.currentSection`,
    parts: state`app.data.parts`,
    answers: state`app.answers`,
    redirect: signal`app.redirect`,
};

export default connect(
    stateSignals,
    MainPage
);



// WEBPACK FOOTER //
// ./src/pages/index.js